import type { IconProps } from '@src/components/icons/IconProps';

/** Key mark — recovery codes and access. */
export function KeyIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="15" r="4" />
      <path d="M11.5 11.5 21 2" />
      <path d="M16 6l2 2" />
      <path d="M19 9l-2 2" />
    </svg>
  );
}
